import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import { useEffect } from 'react';

export default function LoginPage() {
  const { user, isAdmin, isTeacher, loading, error, signInWithGoogle, teacherId } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && isAdmin) {
      navigate('/');
    } else if (user && isTeacher && teacherId) {
      // /teachers/:teacherId/v2 mounts TeacherLayout which auto-redirects
      // to the most-recently-active (batch, subject) per /me/contexts.
      navigate(`/teachers/${teacherId}/v2`);
    }
  }, [user, isAdmin, isTeacher, teacherId, navigate]);

  const handleSignIn = async () => {
    try {
      await signInWithGoogle();
      // Navigation handled by useEffect above
    } catch (err) {
      // Error is handled in useAuth
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-teacher-bg">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teacher-purple-mid"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-gradient">
      <div className="bg-white p-8 rounded-xl shadow-xl max-w-md w-full mx-4 border border-teacher-border">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-semibold tracking-tight mb-2">
            <span className="bg-brand-gradient bg-clip-text text-transparent">JEE</span>
            <span className="bg-brand-gradient bg-clip-text text-transparent">Vibe</span>
          </h1>
          <p className="text-teacher-text-secondary text-sm">Sign in to access your dashboard</p>
        </div>

        {error && (
          <div className="mb-6 p-4 bg-teacher-red-light border border-teacher-red/30 rounded-lg text-teacher-red text-sm">
            {error}
          </div>
        )}

        <button
          onClick={handleSignIn}
          className="w-full flex items-center justify-center gap-3 px-4 py-3 bg-white border border-teacher-border rounded-lg hover:bg-teacher-bg transition-colors shadow-sm"
        >
          <svg className="w-5 h-5" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
            <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
          </svg>
          <span className="text-teacher-text-primary font-medium">Sign in with Google</span>
        </button>

        <p className="mt-6 text-center text-sm text-teacher-text-tertiary">
          For admins and coaching center teachers.
        </p>
      </div>
    </div>
  );
}
